<div
  class="ai-chat-download-card"
  role="button"
  tabindex="0"
  (click)="downloadFile($event)"
  (keydown.enter)="downloadFile($event)"
  [attr.aria-label]="'Descargar ' + (downloadData?.filename || 'archivo')"
>
  <div class="ai-chat-download-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      class="ai-chat-download-icon-svg"
      aria-hidden="true"
    >
      <path d="M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2zm0 5v3h6V8H5zm0 5v3h6v-3H5zm8-5v3h6V8h-6zm0 5v3h6v-3h-6z"/>
    </svg>
  </div>

  <div class="ai-chat-download-info">
    <p class="ai-chat-download-filename" [title]="downloadData?.filename">
      {{ downloadData?.filename }}
    </p>
    <p class="ai-chat-download-subtitle">
      Hoja de cálculo - {{ fileSize }}
    </p>
  </div>

  <button
    type="button"
    class="ai-chat-download-btn"
    (click)="downloadFile($event)"
    [attr.aria-label]="'Descargar ' + (downloadData?.filename || 'archivo')"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      class="ai-chat-download-btn-icon"
      aria-hidden="true"
    >
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
    </svg>
  </button>
</div>
